import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errorText } from "@/lib/api";
import { Logo } from "@/components/Brand";

export default function Restablecer() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Las dos contraseñas no coinciden. Revísalas con calma."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setMessage(data.message);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-papel px-6 py-10 sm:px-12 lg:px-24 lg:py-16" data-testid="reset-page">
      <Logo size={52} testId="reset-logo" />
      <div className="max-w-md w-full mt-14 lg:mt-24 settle">
        <h1 className="font-serif text-4xl text-tinta leading-tight">Crea una contraseña nueva</h1>
        {message ? (
          <div className="mt-8 space-y-6">
            <p className="calm-note" role="status" data-testid="reset-message">{message}</p>
            <Link to="/entrar" className="btn-primary" data-testid="reset-go-login">Entrar</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block" htmlFor="reset-password">
              <span className="block text-[15px] font-medium text-tinta mb-2">Contraseña nueva</span>
              <input id="reset-password" type="password" minLength={8} required className="field" value={password}
                autoComplete="new-password" onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
            </label>
            <label className="block" htmlFor="reset-confirm">
              <span className="block text-[15px] font-medium text-tinta mb-2">Escríbela otra vez</span>
              <input id="reset-confirm" type="password" minLength={8} required className="field" value={confirm}
                autoComplete="new-password" onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
            </label>
            <p className="text-xs text-meta">Al menos 8 caracteres.</p>
            {error && <p className="calm-note" role="status" data-testid="reset-error">{error}</p>}
            <button type="submit" className="btn-primary w-full" disabled={busy || !token} data-testid="reset-submit-button">
              {busy ? "Un momento…" : "Guardar contraseña"}
            </button>
            {!token && <p className="calm-note" data-testid="reset-no-token">Este enlace está incompleto. Pide uno nuevo desde Olvidé mi contraseña.</p>}
          </form>
        )}
      </div>
    </div>
  );
}
